import { clsx } from '@/lib/utils';
import { useTranslation } from 'react-i18next';
import { AppIcon, appIcons } from '@/components/ui/app-icon/app-icon';
import Tooltip from '@mui/material/Tooltip';

interface SupportBoxProps {
    isCollapsed: boolean;
}

function SupportBox({ isCollapsed }: SupportBoxProps) {
    const [t] = useTranslation();

    const handleSupportClick = () => {
        window.location.href = `mailto:${t('support.email')}?subject=${encodeURIComponent(t('support.emailSubject'))}`;
    };

    const SupportContent = (
        <div
            onClick={handleSupportClick}
            className={clsx(
                'px-2 py-3 rounded-lg flex justify-between items-center gap-2 transition-colors cursor-pointer',
                'bg-primary/10 text-primary hover:bg-primary/20',
                isCollapsed && 'justify-center',
            )}>
            <div className={clsx('flex flex-col', isCollapsed && 'items-center')}>
                <div className={clsx('flex items-center gap-2', isCollapsed && 'm-auto', 'h-5')}>
                    <span className="text-primary">
                        <AppIcon icon={appIcons.support} />
                    </span>
                    <span className={clsx('text-sm font-medium', isCollapsed && 'hidden')}>
                        {t('support.title')}
                    </span>
                </div>
                {!isCollapsed && (
                    <div className="pl-6 mt-1">
                        <p className="text-xs text-primary/70">
                            {t('support.description')}{' '}
                            <span className="text-primary/90 font-medium">
                                {t('support.email')}
                            </span>
                        </p>
                    </div>
                )}
            </div>
        </div>
    );

    if (isCollapsed) {
        return (
            <Tooltip title={t('support.title')} placement="right">
                {SupportContent}
            </Tooltip>
        );
    }

    return SupportContent;
}

export default SupportBox;
